import { DataObject } from "@lib/titan2/dist/api/core/data/DataObject";
export class LogParams {
    constructor(messageAcknowledged, gameInstanceId, choices) {
        this.messageAcknowledged = messageAcknowledged;
        this.gameInstanceId = gameInstanceId;
        this.choices = choices;
    }
    liquify() {
        let data = new DataObject();
        data.putNumber("gameInstanceId", this.gameInstanceId);
        data.putPlainObject("data", {
            choices: this.choices
        });
        return data;
    }
}
//# sourceMappingURL=LogParams.js.map